import React, { ComponentProps, FormEvent, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { useToast } from 'contexts/ToastContext'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { Button } from 'components/Button'
import { TextInput } from 'components/TextInput'
import { LoginLayout } from '../LoginLayout'
import { ResetPasswordRoot } from './ResetPassword.styles'
import { SentInstructions } from '../SentInstructions'
import { usePostResetPasswordEmail } from 'features/Login/api/mutations/usePostResetPasswordEmail'

type ResetPasswordOwnProps = ComponentProps<typeof ResetPasswordRoot>
export type ResetPasswordProps = ResetPasswordOwnProps & {}

export const ResetPassword = (_props: ResetPasswordProps) => {
  const { t } = useTranslation()

  const { addToast, removeToast } = useToast()

  const { postResetPasswordEmail } = usePostResetPasswordEmail()

  const header = <Header />

  const [email, setEmail] = useState('')
  const [isEmailSubmitted, setIsEmailSubmitted] = useState(false)

  const submitEmail = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    postResetPasswordEmail(
      { email },
      {
        onSuccess: () => {
          setIsEmailSubmitted(true)
        },
        onError: () => {
          addToast({
            title: t('login:toast.password.error.title'),
            message: t('login:toast.password.error.message'),
            duration: 5000,
            onClose: () => removeToast('error-password'),
            tone: 'error',
            id: 'error-password',
          })
        },
      }
    )
  }

  return (
    <Layout header={header} hideCTA>
      <LoginLayout skipOnboarding>
        {isEmailSubmitted ? (
          <SentInstructions email={email} />
        ) : (
          <ResetPasswordRoot onSubmit={submitEmail}>
            <Stack
              direction="column"
              gap="7"
              justifyContent={{ '@initial': 'space-between', '@bp2': 'center' }}
            >
              <Stack direction="column" gap={{ '@initial': '4', '@bp2': '7' }}>
                <Text
                  size={{ '@initial': 'h4', '@bp2': 'h3' }}
                  as="h3"
                  weight="bold"
                  color="primary-800"
                >
                  {t('reset-password:title')}
                </Text>
                <Stack direction="column" gap={{ '@initial': '3', '@bp2': '4' }}>
                  <Text size={{ '@initial': 'body', '@bp2': 'headline' }} color="tertiary-900">
                    {t('reset-password:description')}
                  </Text>
                  <TextInput
                    type="email"
                    label={t('reset-password:email')}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                  />
                </Stack>
              </Stack>
              <Button>{t('reset-password:title')}</Button>
            </Stack>
          </ResetPasswordRoot>
        )}
      </LoginLayout>
    </Layout>
  )
}

ResetPassword.displayName = 'ResetPassword'
